import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';

const state = () => ({
    data: [],
    loading: false,
    loadingOverview: false,
    loadingLabels: false,
    labelsDonut: [],
    ticketsDonut: [],
    error: null,
});

const actions = {
    async dashboardOverview({commit}) {
        commit('dashboardOverviewBegin');
        await DataService.get('/dashboard/overview').then(response => {
            commit('dashboardOverviewSuccess', response.data.data);
        }).catch(err => {
            commit('dashboardOverviewErr', err);
        });
    },

    async dashboardLabel({commit}) {
        commit('dashboardLabelBegin');
        await DataService.get('/dashboard/contacts-by-label').then(response => {
            commit('dashboardLabelSuccess', response.data.data);
        }).catch(err => {
            console.log("err", err);
        });
    },

    async dashboardTicketsCount({commit}) {
        commit('dashboardTicktesCountBegin');
        await DataService.get('/ticket/count').then(response => {
            commit('dashboardTicketsCountSuccess', response.data.data);
        }).catch(err => {
            commit('dashboardTicktesCountErr', err);
        });
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};